import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import LinearProgress from '@mui/material/LinearProgress';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CloseIcon from '@mui/icons-material/Close';
import { useUpload } from '../../shared/context/UploadContext';

export default function UploadProgressPanel() {
    const { isUploading, uploadPercentage, uploadDisplayName, isUploadComplete, hasUploadError, isUploadForegrounded, dismissUploadBar } = useUpload();

    if (isUploadForegrounded || (!isUploading && !isUploadComplete && !hasUploadError)) return null;

    const isDismissible = isUploadComplete || hasUploadError;

    return (
        <Paper
            role="status"
            elevation={4}
            sx={{
                position: 'fixed',
                bottom: 16,
                right: 16,
                zIndex: 'snackbar',
                width: 320,
                p: 2,
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, overflow: 'hidden', minWidth: 0 }}>
                    <CloudUploadIcon color="primary" fontSize="small" sx={{ flexShrink: 0 }} />
                    <Typography variant="body2" fontWeight="medium" noWrap>
                        {uploadDisplayName}
                    </Typography>
                </Box>
                {isDismissible && (
                    <IconButton
                        size="small"
                        onClick={dismissUploadBar}
                        aria-label="Dismiss upload notification"
                    >
                        <CloseIcon fontSize="small" />
                    </IconButton>
                )}
            </Box>

            {isUploading && (
                <>
                    <Typography variant="caption" color="text.secondary">
                        Uploading… {uploadPercentage}%
                    </Typography>
                    <LinearProgress
                        variant="determinate"
                        value={uploadPercentage}
                        sx={{ mt: 0.5, borderRadius: 1 }}
                    />
                </>
            )}

            {isUploadComplete && (
                <Typography variant="caption" color="success.main">
                    Upload complete
                </Typography>
            )}

            {hasUploadError && (
                <Typography variant="caption" color="error.main">
                    Upload failed
                </Typography>
            )}
        </Paper>
    );
}
